<template>
    <div class="discount-component">
        <p class="mt-3" v-if="! descuentos">{{ trans.get('wizard.promotiondescrition') }}</p>
        <div class="block lg:flex mt-3" v-if="! descuentos">
            <input type="text" v-model="discount" name="discount" class="block mx-auto my-8 lg:my-0 input-descuento pl-3 lg:mr-3" :placeholder="trans.get('wizard.codefield')">
            <btn-secondary
                class="block mx-auto"
                :handle-click="submit"
                :loading="loading"
                :text="trans.get('wizard.applycode')"
            ></btn-secondary>
        </div>
        <div>
            <p v-if="codeerror" class="py-3 m-0" style="color:red">{{codeerror}}</p>
            <p v-if="CouponMessage" class="" style="color:red">{{CouponMessage}}</p>
            <p v-if="codemessage" class="py-3" style="color:green">{{codemessage}}</p>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import { mapMutations, mapGetters } from 'vuex';
import BtnSecondary from "@/js/components/common/buttons/BtnSecondary";
import { GET_TOTAL } from "@/js/store/cart/types";

export default {
    components: {
        BtnSecondary
    },
    data() {
        return {
            discount: null,
            results: '',
            codeerror: '',
            loading: false,
            lang: window.appLocale,
            errorMessage: {
                en: 'This code is not valid',
                es: 'Este código no es válido',
                fr: 'Ce code n’est pas valide',
                de: 'Dieser Code ist nicht gultig',
            },
            successMessage: {
                en: 'Code added successfully!',
                es: 'Codigo anadido conxito!',
                fr: 'Code ajouté avec succéss!',
                de: 'Code hinzugefunden!',
            }
        }
    },
    methods: {
        ...mapMutations(['setCoupon']),
        submit(){
            this.loading = true;
            axios.get(`/coupon`, {params: {discount: this.discount, value: this.getTotal, type: 'monto'}})
                .then(response => {
                    this.setCoupon(response.data);
                })
                .catch(error => {
                    this.codeerror= this.errorMessage[this.lang];
                })
                .finally(() => this.loading = false);
        }
    },
    computed: {
        ...mapGetters({
            descuentos: 'getCouponApplicable',
            CouponMessage: 'getCouponMessage',
            getTotal: GET_TOTAL
        }),
        codemessage() {
            if(this.descuentos){
                this.codeerror = '';
                return this.successMessage[this.lang];
            }else if(this.results && !this.descuentos){
                return false;
            }
        }
    },
}
</script>
<style lang="scss" scoped>
.input-descuento{
    background-color: #f5f5f5;
    padding: 11px;
}
.discount-component {
    margin-bottom: 40px;
    @media (min-width: 1050px) {
        margin-bottom: 50px;
    }
}
</style>
